var map = {
	"./de.json": [
		1843,
		2
	],
	"./de_CH.json": [
		1884,
		63
	],
	"./en.json": [
		657
	],
	"./en_CA.json": [
		1885,
		1
	],
	"./en_CH.json": [
		1886,
		0
	],
	"./en_GB.json": [
		1887,
		0
	],
	"./fr.json": [
		1888,
		64
	],
	"./fr_CA.json": [
		1889,
		8
	],
	"./fr_CH.json": [
		1890,
		0
	],
	"./it.json": [
		1891,
		65
	],
	"./it_CH.json": [
		1844,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 767;
module.exports = webpackAsyncContext;